export default function ($translate) {
    return {
        KEYS: {
            UNLIMITED: 'UNLIMITED'
        },
        LABELS: {
            UNLIMITED: $translate.instant('form.Unlimited')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/form/repeat/index.js